const features = [
  {
    icon: 'ri-4k-line',
    title: '4K蓝光画质',
    desc: '支持4K HDR超高清播放，蓝光影视资源级别画质呈现，每一个细节都清晰锐利，还原影院级视觉体验。',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '自研智能播放引擎搭配全球CDN加速，高清电影在线观看秒开不缓冲，弱网环境也能流畅播放。',
    color: 'bg-accent-100 text-accent-800',
  },
  {
    icon: 'ri-stack-line',
    title: '海量片源库',
    desc: '10万+高清影视资源，涵盖电影、电视剧、综艺、纪录片等全品类，高清电视剧免费全集持续更新。',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    desc: '支持手机、平板、电脑和智能电视，观影记录与收藏全平台同步，随时随地继续你的高清影视大全之旅。',
    color: 'bg-primary-100 text-primary-700',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <h2 className="font-display text-2xl md:text-3xl text-foreground-950 text-center mb-2">核心优势</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">为什么选择91影视看片app？</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {features.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-lg p-5 md:p-6 text-center group hover:bg-background-50 transition-colors">
              <div className={`w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-xl flex items-center justify-center ${item.color}`}>
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}